<style>

.holder {
    padding-top: 10px;
    padding-bottom: 10px;
}
.poll-option-holder {
    padding-top: 5px;
    padding-bottom: 5px;
}

.poll-option {
    padding: 5px;
    padding-left: 15px;
    background-color: whitesmoke;
    border:1px solid rgb(223, 223, 223);
    border-radius: 10px;
    cursor: pointer;
    width: 50%;
    margin: 10px;
    margin-left: 0px;
}

.poll-option:hover {
    background-color: black;
    border-color: black;
    color: white;
}

a {
    cursor: pointer;
    font-size: 12px;
}

.label {
    padding-top: 15px;
    font-weight: bold;
}

.poll-result-holder {
    padding-top: 5px;
    padding-bottom: 5px;
}

.poll-result {
    padding: 5px;
    border:1px solid rgb(223, 223, 223);
    border-radius: 10px;
    width: 50%;
    margin: 10px;
    margin-left: 0px;
    display: flex;
    flex-direction: column;
}

.poll-result-bar-holder {
    width: 100%;
    background-color: whitesmoke;
}

.poll-result-bar {
    background-color: black;
    border-radius: 5px;
    height: 5px;
    position: relative;
}

.poll-result-info {
    width: 100%;
    display: flex;
    padding-top: 5px;
}

.poll-result-info-name {
    padding-left: 5px;
    flex: 1;
}

.poll-result-info-votes {
    padding-right: 5px;
    text-align: right;
    flex: 1;
}

</style>

<script>
    import {onMount} from 'svelte'
    import * as Common from './Common.js'

    export let item_id

    $: totalVotes = options.reduce((tot,n) => tot + n.votes, 0)

    let options = []
    let showResults = false

    onMount(async () => {
        Common.getData('item/poll/'+item_id)
        .then(data => {
            if(!data) {
                alert("Error Retrieving Poll")
                return
            }

            options = data
        })
    })

    function submitVote(option) {
        Common.putData('item/poll/option/'+option.id)
        .then(r => {
            if(!r.ok) {
                if(r.code === 406) {
                    alert("Already Voted on this Poll!")
                } else {
                    alert("Problem submitting Vote.")
                }
                return
            }
            option.votes += 1
            totalVotes += 1
            Common.CreateNotification({body: "Thank you for your vote!"}, 1000)
            toggleShowResults()
        })
    }

    function toggleShowResults() {
        showResults = !showResults
    }

    function barWidth(total, optionVotes) {
        if(total === 0)
            return "0%"
        return ((optionVotes/total) * 100) + "%"
    }
</script>

<div class="holder">
    {#if !showResults}
        <div class="label">Poll:</div>
        <div class="poll-option-holder">
            {#each options as option}
                <div class="poll-option" on:click={() => submitVote(option)}>
                    {option.text}
                </div>
            {/each}
        </div>
    <a on:click={toggleShowResults}>View Results</a>
    {:else}
        <div class="label">Poll Results ({totalVotes} Votes Total):</div>
        <div class="poll-result-holder">
            {#each options.sort((a,b) => b.votes - a.votes) as option}
                <div class="poll-result">
                    <div class="poll-result-bar-holder">
                        <div class="poll-result-bar" style={"width:" + barWidth(totalVotes, option.votes)}></div>
                    </div>
                    <div class="poll-result-info">
                        <div class="poll-result-info-name">{option.text}</div>
                        <div class="poll-result-info-votes">{option.votes} Votes</div>
                    </div>
                </div>
            {/each}
        </div>
    {/if}
</div>
